import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63ae9458"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "图片")
], -1))
const _hoisted_3 = { class: "submit-btn" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 提交 ")

import { onActivated, onMounted, reactive, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import SimpImageUpload from '@/components/SimpImageUpload.vue'
import dayjs from 'dayjs'
import { saveFollowLog } from '@/apis/progressReport'
import { Toast } from 'vant'
import { uploadFileItem } from '@/apis/base'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const state = reactive({
  formData: {
    project_id: null,
    content: null,
    project_name: '',
    pics: null
  }
})

const fileList = ref<Array<uploadFileItem>>([])
watch(fileList, (newVal, oldVal) => {
  state.formData.pics = newVal
})

onActivated(() => {})

const onSubmit = async () => {
  let data = {
    content: state.formData.content,
    pics: state.formData.pics,
    project_id: state.formData.project_id
  }

  const res = await saveFollowLog(data)
  if (res.code == 200) {
    console.log(res.data)
    Toast.success({
      message: res.msg,
      duration: 500,
      onClose: () => {
        router.back()
      }
    })
  } else {
    Toast(res.msg)
  }
}

const onFailed = errorInfo => {
  console.log('failed', errorInfo)
}
const StaffInfo = ref({
  currentTime: '--', // 当前时间
  company_froms: {
    cf_name: '--'
  },
  name: '--'
})

onMounted(() => {
  StaffInfo.value = JSON.parse(localStorage.getItem('STAFFINFO'))
  StaffInfo.value.currentTime = dayjs().format('YYYY-MM-DD HH:mm')
  console.log(router.currentRoute.value.query.project_id)
  console.log(router.currentRoute.value.query.project_name)
  state.formData.project_id = router.currentRoute.value.query.project_id
  state.formData.project_name = router.currentRoute.value.query.project_name.toString()
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_common_info = _resolveComponent("common-info")!
  const _component_bottom_button = _resolveComponent("bottom-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_van_form, {
      class: "form",
      onSubmit: onSubmit,
      onFailed: onFailed,
      "input-align": "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: "项目名称",
              value: _unref(state).formData.project_name
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_field, {
          style: {"display":"block"},
          modelValue: _unref(state).formData.content,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).formData.content) = $event)),
          required: "",
          name: "content",
          label: "汇报内容",
          "input-align": "left",
          type: "textarea",
          rows: "5",
          placeholder: "请输入"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_cell, null, {
          title: _withCtx(() => [
            _hoisted_2
          ]),
          label: _withCtx(() => [
            _createVNode(SimpImageUpload, {
              isShowTitle: false,
              modelValue: fileList.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fileList).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_common_info, { StaffInfo: StaffInfo.value }, null, 8, ["StaffInfo"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_bottom_button, {
            round: "",
            block: "",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})